import { config, library } from '@fortawesome/fontawesome-svg-core';
import {
  faPhone,
  faEnvelope,
  faLocationDot,
  faBars,
  faXmark,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faCheck,
  faCircleNotch,
  faArrowRight,
  faShield,
  faStar,
  faTrowel,
  faHelmetSafety,
  faHouse,
  faRoad,
  faTree,
  faDroplet,
  faSprayCanSparkles,
  faClock,
  faPhoneVolume,
  faBriefcase,
  faAward,
  faRightFromBracket,
  faTriangleExclamation,
  faCode,
} from '@fortawesome/free-solid-svg-icons';
import { faGoogle, faFacebookF, faXTwitter, faTiktok, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faQuoteLeft, faStar as faStarSolid, faMessage, faCommentDots, faPlus } from '@fortawesome/free-solid-svg-icons';

// Don't auto-add the FA CSS via JS - we import it from index.css instead
// so first paint isn't FOUC-y.
config.autoAddCss = false;

library.add(
  faPhone,
  faEnvelope,
  faLocationDot,
  faBars,
  faXmark,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faCheck,
  faCircleNotch,
  faArrowRight,
  faShield,
  faStar,
  faTrowel,
  faHelmetSafety,
  faHouse,
  faRoad,
  faTree,
  faDroplet,
  faSprayCanSparkles,
  faClock,
  faPhoneVolume,
  faBriefcase,
  faAward,
  faRightFromBracket,
  faTriangleExclamation,
  faCode,
  faGoogle,
  faFacebookF,
  faXTwitter,
  faTiktok,
  faWhatsapp,
  faQuoteLeft,
  faStarSolid,
  faMessage,
  faCommentDots,
  faPlus,
);
